export default (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
    <rect width="100" height="100" rx="20" fill="#0D0D0D" />
    <path
      d="M15 72 L32 38 L42 55 L50 28 L58 55 L68 38 L85 72"
      fill="none"
      stroke="white"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
